import {
  getLogin,
  completeNewPassword,
  refreshTokenAction,
  fetchCheckAccessToken,
} from "./actions";
import {
  getMissionPlannerData,
  getShowGlobalLoader,
  getExpirationDate,
  getBackUrl,
  getCurrentSemanticMapId,
  getActiveTooltipVehicleId,
  getNewPasswordChallenge,
} from "./selectors";
import AppStateSlice from "./reducers";

// actions
export const {
  setLoginErrorText,
  setNewPasswordChallenge,
  setMissionPlannerData,
  setCurrentSemanticMapId,
  setExpirationDate,
  setBackUrl,
  setShowGlobalLoader,
  setActiveTooltipVehicleId,
  resetAppState,
} = AppStateSlice.actions;

// async actions
export {
  getLogin,
  completeNewPassword,
  refreshTokenAction,
  fetchCheckAccessToken,
};

// selectors
export {
  getMissionPlannerData,
  getShowGlobalLoader,
  getExpirationDate,
  getBackUrl,
  getCurrentSemanticMapId,
  getActiveTooltipVehicleId,
  getNewPasswordChallenge,
};

// reducer
export default AppStateSlice.reducer;
